import React, { Component } from 'react'
import './card.css'
import theme from '../../config/theme'
const whitelabel = process.env.REACT_APP_NAME

export default class CardFlwt extends Component {
    constructor(props) {
        super(props)
        this.state = {
            whitelabel: whitelabel
        }
    }
    render() {
        return (
            <div className="cardFlwtWrapper" style={{
                borderColor: theme.colors.background,
            }}>
                {/* <img src={theme.logos.white} className="img-fluid logoFlwt" alt="logo" /> */}
                <div className="flwtContent mt-5" style={{
                    backgroundColor: theme.colors.background,
                }}>
                    <img src={theme.logos.dark} className="img-fluid moedaFlwt" alt="logo" />
                    <h2 className="font-weight-bold titleFlwtCard mb-0" style={{
                        color: theme.colors.white,
                        fontFamily: theme.typography.fontFamily.bold
                    }}>
                        {whitelabel} Wallet LP Token
                    </h2>
                    <label className="mt-1 mb-0" style={{
                        color: theme.colors.primaryDark
                    }}>grass</label>
                    <div className="d-flex w-100 justify-content-between mt-3">
                        <label className="font-weight-bold mb-0" style={{
                            color: theme.colors.white,
                            fontFamily: theme.typography.fontFamily.bold
                        }}>Preço</label>
                        <label className="font-weight-bold mb-0" style={{
                            color: theme.colors.white,
                            fontFamily: theme.typography.fontFamily.bold
                        }}>R$500</label>
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <label className="tokenTag mb-0">utility token</label>
                        <label className="tokenTag mb-0">permission token</label>
                    </div>
                </div>
            </div>
        )
    }
}